import script from "./AssetDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetDetail.vue?vue&type=script&setup=true&lang=js"

import "./AssetDetail.vue?vue&type=style&index=0&id=637044b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637044b2"]])

export default __exports__